<header
  class="h-16 bg-card flex items-center justify-between pl-4 pr-4 shrink-0 z-30"
  [class.border-b]="!hideBorder"
  [class.border-border]="!hideBorder"
>
  <a (click)="goToHome()" class="cursor-pointer shrink-0" role="button">
    <img [src]="logoUrl" alt="HRM Cloud Logo" class="h-8 w-auto" />
  </a>
  <div class="flex-1 shrink-0 max-w-screen-2xl">
    <div class="flex items-center justify-between ">

      <div class="flex items-center gap-4 flex-1 min-w-0">
      <button
        type="button"
        (click)="onMenuClick()"
        class="lg:hidden p-2 -ml-2 text-muted-foreground"
      >
        <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
          <path fill-rule="evenodd" d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
        </svg>
      </button>

      <div class="relative w-full max-w-md hidden sm:block">
        <svg class="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground w-[18px] h-[18px]" viewBox="0 0 24 24" fill="currentColor">
          <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 4.243 11.998l4.254 4.254a.75.75 0 1 0 1.06-1.06l-4.254-4.254A6.75 6.75 0 0 0 10.5 3.75Zm-5.25 6.75a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0Z" clip-rule="evenodd" />
        </svg>
        <input
          type="text"
          class="w-full pl-10 pr-4 py-2 bg-background border border-border text-foreground placeholder:text-muted-foreground focus:border-primary transition-all outline-none rounded-lg text-sm"
          [placeholder]="searchPlaceholder"
        />
      </div>
      </div>

      <div class="flex items-center gap-3">
        <button
          type="button"
          (click)="toggleMobileSearch()"
          class="p-2 text-muted-foreground hover:bg-muted-foreground/20 rounded-full transition-colors sm:hidden"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" class="w-6 h-6">
            <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clip-rule="evenodd" />
          </svg>
        </button>

        <!-- <button
          type="button"
          (click)="toggleTheme()"
          class="p-2 text-muted-foreground hover:bg-muted-foreground/20 rounded-full transition-colors hidden sm:block"
          [attr.title]="isDarkMode ? 'Chuyển sang chế độ sáng' : 'Chuyển sang chế độ tối'"
        >
          <ng-container *ngIf="isDarkMode">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" class="w-6 h-6">
              <path d="M12 2.25a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Zm0 15.75a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 12 18Zm9-6.75a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1 0-1.5H21ZM4.5 12a.75.75 0 0 1-.75.75H2.25a.75.75 0 0 1 0-1.5h1.5A.75.75 0 0 1 4.5 12Zm13.864-6.364a.75.75 0 0 1 1.06 1.06l-1.06 1.061a.75.75 0 0 1-1.061-1.06l1.061-1.06ZM6.697 17.303a.75.75 0 0 1 1.06 0l1.061 1.06a.75.75 0 1 1-1.06 1.061l-1.061-1.06a.75.75 0 0 1 0-1.061Zm12.727 1.06a.75.75 0 0 1-1.06 1.061l-1.061-1.06a.75.75 0 0 1 1.06-1.061l1.061 1.06ZM8.818 6.697a.75.75 0 0 1-1.06 1.06L6.696 6.697a.75.75 0 1 1 1.061-1.06l1.06 1.06ZM12 6.75A5.25 5.25 0 1 0 12 17.25 5.25 5.25 0 0 0 12 6.75Z" />
            </svg>
          </ng-container>
          <ng-container *ngIf="!isDarkMode">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" class="w-6 h-6">
              <path fill-rule="evenodd" d="M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z" clip-rule="evenodd" />
            </svg>
          </ng-container>
        </button>

        <button type="button" class="p-2 text-muted-foreground hover:bg-muted-foreground/20 rounded-full transition-colors hidden sm:block">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" class="w-6 h-6">
            <path fill-rule="evenodd" d="M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z" clip-rule="evenodd" />
          </svg>
        </button>

        <button type="button" class="p-2 text-muted-foreground hover:bg-muted-foreground/20 rounded-full transition-colors hidden sm:block">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" class="w-6 h-6">
            <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" />
          </svg>
        </button>

        <div class="relative">
          <button
            type="button"
            (click)="toggleLanguageDropdown()"
            [attr.class]="'p-2 rounded-full transition-colors hidden sm:block ' + (isLanguageDropdownOpen ? 'bg-muted text-primary' : 'text-muted-foreground hover:bg-muted-foreground/20')"
            title="Chuyển đổi ngôn ngữ"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" class="w-6 h-6">
              <path d="M21.721 12.752a9.711 9.711 0 0 0-.945-5.003 12.754 12.754 0 0 1-4.339 2.708 18.991 18.991 0 0 1-.214 4.772 17.165 17.165 0 0 0 5.498-2.477ZM14.634 15.55a17.324 17.324 0 0 0 .332-4.647c-.952.227-1.945.347-2.966.347-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 0 0 .332 4.647 17.385 17.385 0 0 0 5.268 0ZM9.772 17.119a18.963 18.963 0 0 0 4.456 0A17.182 17.182 0 0 1 12 21.724a17.18 17.18 0 0 1-2.228-4.605ZM7.777 15.23a18.87 18.87 0 0 1-.214-4.774 12.753 12.753 0 0 1-4.34-2.708 9.711 9.711 0 0 0-.944 5.004 17.165 17.165 0 0 0 5.498 2.477ZM21.356 14.752a9.765 9.765 0 0 1-7.478 6.817 18.64 18.64 0 0 0 1.988-4.718 18.627 18.627 0 0 0 5.49-2.098ZM2.644 14.752c1.682.971 3.53 1.688 5.49 2.099a18.64 18.64 0 0 0 1.988 4.718 9.765 9.765 0 0 1-7.478-6.816ZM13.878 2.43a9.755 9.755 0 0 1 6.116 3.986 11.267 11.267 0 0 1-3.746 2.504 18.63 18.63 0 0 0-2.37-6.49ZM12 2.276a17.152 17.152 0 0 1 2.805 7.121c-.897.23-1.837.353-2.805.353-.968 0-1.908-.122-2.805-.353A17.151 17.151 0 0 1 12 2.276ZM10.122 2.43a18.629 18.629 0 0 0-2.37 6.49 11.266 11.266 0 0 1-3.746-2.504 9.754 9.754 0 0 1 6.116-3.985Z" />
            </svg>
          </button>

          <ng-container *ngIf="isLanguageDropdownOpen">
            <div class="fixed inset-0 z-[90]" (click)="isLanguageDropdownOpen = false"></div>
            <div class="absolute right-0 top-full mt-2 bg-card border border-border z-[100] min-w-[180px] rounded-lg shadow-md">
              <div class="py-2">
                <button
                  type="button"
                  (click)="changeLanguage('vi')"
                  [attr.class]="'w-full flex items-center justify-between gap-3 px-4 py-2 transition-colors ' + (currentLanguage === 'vi' ? 'bg-primary/10 text-primary' : 'text-foreground hover:bg-muted')"
                >
                  <div class="flex items-center gap-2">
                    <span class="fi fi-vn" style="width: 20px; height: 15px"></span>
                    <h5>Tiếng Việt</h5>
                  </div>
                  <div *ngIf="currentLanguage === 'vi'" class="w-1.5 h-1.5 rounded-full bg-primary"></div>
                </button>
                <button
                  type="button"
                  (click)="changeLanguage('en')"
                  [attr.class]="'w-full flex items-center justify-between gap-3 px-4 py-2 transition-colors ' + (currentLanguage === 'en' ? 'bg-primary/10 text-primary' : 'text-foreground hover:bg-muted')"
                >
                  <div class="flex items-center gap-2">
                    <span class="fi fi-gb" style="width: 20px; height: 15px"></span>
                    <h5>English</h5>
                  </div>
                  <div *ngIf="currentLanguage === 'en'" class="w-1.5 h-1.5 rounded-full bg-primary"></div>
                </button>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="relative" *ngIf="!hideModuleSelector">
          <button
            type="button"
            (click)="toggleModuleDropdown()"
            [attr.class]="'p-2 rounded-full transition-colors ' + (isModuleDropdownOpen ? 'bg-muted text-primary' : 'text-muted-foreground hover:bg-muted-foreground/20')"
          >
            <svg class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M5.25 3A2.25 2.25 0 0 0 3 5.25v3A2.25 2.25 0 0 0 5.25 10.5h3A2.25 2.25 0 0 0 10.5 8.25v-3A2.25 2.25 0 0 0 8.25 3h-3ZM5.25 13.5A2.25 2.25 0 0 0 3 15.75v3A2.25 2.25 0 0 0 5.25 21h3a2.25 2.25 0 0 0 2.25-2.25v-3a2.25 2.25 0 0 0-2.25-2.25h-3ZM13.5 5.25A2.25 2.25 0 0 1 15.75 3h3A2.25 2.25 0 0 1 21 5.25v3a2.25 2.25 0 0 1-2.25 2.25h-3a2.25 2.25 0 0 1-2.25-2.25v-3ZM15.75 13.5a2.25 2.25 0 0 0-2.25 2.25v3A2.25 2.25 0 0 0 15.75 21h3A2.25 2.25 0 0 0 21 18.75v-3a2.25 2.25 0 0 0-2.25-2.25h-3Z" />
            </svg>
          </button>

          <ng-container *ngIf="isModuleDropdownOpen">
            <div class="fixed inset-0 z-[90]" (click)="isModuleDropdownOpen = false"></div>
            <div class="absolute top-full mt-2 bg-card border border-border z-[100] p-3 w-[520px] rounded-lg shadow-md" style="right: -220px">
              <div class="pb-3 border-b border-border mb-3">
                <h3 class="text-foreground font-medium">Các Module</h3>
                <p class="text-muted-foreground mt-0.5 text-xs">Chọn module để truy cập</p>
              </div>
              <div class="grid grid-cols-3 gap-[6px]">
                <div class="content-stretch flex flex-col gap-[12px] items-center justify-center p-[16px] relative rounded-[12px] cursor-pointer transition-all hover:bg-muted">
                  <div class="relative shrink-0 size-[40px] bg-muted rounded-lg"></div>
                  <div class="flex flex-col gap-[4px] items-center text-center w-full">
                    <p class="text-sm text-foreground">Nhân sự</p>
                    <p class="text-xs text-muted-foreground">Quản lý nhân sự</p>
                  </div>
                </div>
                <div class="content-stretch flex flex-col gap-[12px] items-center justify-center p-[16px] relative rounded-[12px] cursor-pointer transition-all hover:bg-muted">
                  <div class="relative shrink-0 size-[40px] bg-muted rounded-lg"></div>
                  <div class="flex flex-col gap-[4px] items-center text-center w-full">
                    <p class="text-sm text-foreground">Module</p>
                    <p class="text-xs text-muted-foreground">Mô tả</p>
                  </div>
                </div>
                <div class="content-stretch flex flex-col gap-[12px] items-center justify-center p-[16px] relative rounded-[12px] cursor-pointer transition-all hover:bg-muted">
                  <div class="relative shrink-0 size-[40px] bg-muted rounded-lg"></div>
                  <div class="flex flex-col gap-[4px] items-center text-center w-full">
                    <p class="text-sm text-foreground">Module</p>
                    <p class="text-xs text-muted-foreground">Mô tả</p>
                  </div>
                </div>
              </div>
              <div class="pt-3 border-t border-border mt-3">
                <button
                  type="button"
                  (click)="onNavigateToModulesClick()"
                  class="w-full flex items-center justify-center gap-2 px-3 py-2 text-primary hover:bg-primary/10 transition-colors rounded-md"
                >
                  <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                    <path fill-rule="evenodd" d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" />
                  </svg>
                  <h5 class="font-medium">Xem tất cả module</h5>
                </button>
              </div>
            </div>
          </ng-container>
        </div> -->

        <div class="relative">
          <button
            type="button"
            (click)="toggleUserMenu()"
            class="h-auto border-none flex items-center gap-2 !pl-2 !pr-4 !py-1.5 transition-colors !rounded-full min-w-0 hover:bg-muted/80 active:bg-muted"
          >
            <div
              class="w-[32px] h-[32px] shrink-0 rounded-full overflow-hidden bg-muted bg-center bg-no-repeat bg-cover aspect-square"
              [style.background-image]="'url(' + (avatarUrl || defaultAvatarUrl) + ')'"
            ></div>
            <div class="text-left min-w-0 hidden lg:block">
              <p class="text-foreground truncate font-medium text-sm">{{ userName }}</p>
              <p class="text-muted-foreground truncate text-xs">{{ userEmail }}</p>
            </div>
          </button>

          <ng-container *ngIf="isUserMenuOpen">
            <div class="fixed inset-0 z-[90]" (click)="isUserMenuOpen = false"></div>
            <div class="absolute right-0 top-full mt-2 min-w-[12rem] bg-card border border-border z-[100] rounded-lg shadow-lg py-1">
              <button type="button" class="w-full flex items-center gap-3 px-[8px] py-[16px] border-none h-auto text-left text-foreground hover:bg-muted/80 transition-colors border-b border-border">
                <svg class="w-[16px] h-[16px] shrink-0 text-muted-foreground" viewBox="0 0 24 24" fill="currentColor">
                  <path fill-rule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clip-rule="evenodd" />
                </svg>
                <span class="text-sm font-medium whitespace-nowrap">Tài khoản của tôi</span>
              </button>
              <button type="button" class="w-full flex items-center gap-3 px-[8px] py-[16px] border-none h-auto text-left text-foreground hover:bg-muted/80 transition-colors border-b border-border">
                <svg class="w-[16px] h-[16px] shrink-0 text-muted-foreground" viewBox="0 0 24 24" fill="currentColor">
                  <path fill-rule="evenodd" d="M11.49 3.17a.75.75 0 0 1 1.02 0l.727.664a1.5 1.5 0 0 0 1.456.338l.965-.29a.75.75 0 0 1 .908.502l.26.884a1.5 1.5 0 0 0 1.09 1.032l.9.217a.75.75 0 0 1 .556.856l-.13.915a1.5 1.5 0 0 0 .53 1.397l.713.607a.75.75 0 0 1 .182 1.002l-.522.844a1.5 1.5 0 0 0 0 1.552l.522.844a.75.75 0 0 1-.182 1.002l-.713.607a1.5 1.5 0 0 0-.53 1.397l.13.915a.75.75 0 0 1-.556.856l-.9.217a1.5 1.5 0 0 0-1.09 1.032l-.26.884a.75.75 0 0 1-.908.502l-.965-.29a1.5 1.5 0 0 0-1.456.338l-.727.664a.75.75 0 0 1-1.02 0l-.727-.664a1.5 1.5 0 0 0-1.456-.338l-.965.29a.75.75 0 0 1-.908-.502l-.26-.884a1.5 1.5 0 0 0-1.09-1.032l-.9-.217a.75.75 0 0 1-.556-.856l.13-.915a1.5 1.5 0 0 0-.53-1.397l-.713-.607a.75.75 0 0 1-.182-1.002l.522-.844a1.5 1.5 0 0 0 0-1.552l-.522-.844a.75.75 0 0 1 .182-1.002l.713-.607a1.5 1.5 0 0 0 .53-1.397l-.13-.915a.75.75 0 0 1 .556-.856l.9-.217a1.5 1.5 0 0 0 1.09-1.032l.26-.884a.75.75 0 0 1 .908-.502l.965.29a1.5 1.5 0 0 0 1.456-.338l.727-.664ZM12 15.75A3.75 3.75 0 1 0 12 8.25a3.75 3.75 0 0 0 0 7.5Z" clip-rule="evenodd" />
                </svg>
                <span class="text-sm font-medium whitespace-nowrap">Cài đặt</span>
              </button>
              <button
                type="button"
                (click)="onLogoutClick()"
                class="w-full flex items-center gap-3 px-[8px] py-[16px] !border-t border-b-0 h-auto text-left text-red-600 hover:bg-destructive/10 transition-colors"
              >
                <svg class="w-[16px] h-[16px] shrink-0 text-red-600" viewBox="0 0 24 24" fill="currentColor">
                  <path fill-rule="evenodd" d="M7.5 3.75A2.25 2.25 0 0 0 5.25 6v12A2.25 2.25 0 0 0 7.5 20.25h3a.75.75 0 0 0 0-1.5h-3A.75.75 0 0 1 6.75 18V6A.75.75 0 0 1 7.5 5.25h3a.75.75 0 0 0 0-1.5h-3Zm9.22 4.72a.75.75 0 0 0-1.06 1.06l1.72 1.72H10.5a.75.75 0 0 0 0 1.5h6.88l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3Z" clip-rule="evenodd" />
                </svg>
                <span class="text-sm font-medium whitespace-nowrap">Đăng xuất</span>
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</header>

<div *ngIf="isMobileSearchOpen" class="fixed inset-0 bg-card z-50 sm:hidden">
  <div class="h-16 border-b border-border flex items-center gap-3 px-3">
    <button type="button" (click)="toggleMobileSearch()" class="p-2 text-muted-foreground">
      <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
        <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 0 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
      </svg>
    </button>
    <div class="relative flex-1">
      <svg class="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground w-[18px] h-[18px]" viewBox="0 0 24 24" fill="currentColor">
        <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 4.243 11.998l4.254 4.254a.75.75 0 1 0 1.06-1.06l-4.254-4.254A6.75 6.75 0 0 0 10.5 3.75Zm-5.25 6.75a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0Z" clip-rule="evenodd" />
      </svg>
      <input
        type="text"
        autofocus
        class="w-full pl-10 pr-4 py-2 bg-background border border-border text-foreground placeholder:text-muted-foreground focus:border-primary transition-all outline-none rounded-lg text-sm"
        placeholder="Tìm kiếm ứng dụng"
      />
    </div>
  </div>
</div>
